import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { ProjectList } from "../helpers/ProjectList";
import GitHubIcon from '@mui/icons-material/GitHub';
import LanguageIcon from '@mui/icons-material/Language';
import "../styles/ProjectDisplay.css";

function ProjectDisplay() {
  const { id } = useParams();
  const project = ProjectList[id];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="project">
      <img src={project.image} alt={project.name} className="project-image animate-item animate-delay-1" />
      <h1 className="animate-item animate-delay-2"> {project.name}</h1>
      {project.description && (<p className="project-description animate-item animate-delay-3">{project.description}</p>)}
      <p className="project-skills animate-item animate-delay-4"><b>Skills:</b> {project.skills}</p>
      <div className="project-links animate-item animate-delay-5">
        {project.githubUrl && (
          <a href={project.githubUrl} target="_blank" rel="noopener noreferrer" className="project-link">
            <GitHubIcon />
          </a>
        )}
        {project.websiteUrl && (
          <a href={project.websiteUrl} target="_blank" rel="noopener noreferrer" className="project-link" style={{ marginLeft: "15px" }}>
            <LanguageIcon />
          </a>
        )}
      </div>
    </div>
  );
}

export default ProjectDisplay;
